export default __webpack_public_path__ + "static/media/2DA23858-B5ED-4AA9-AF71-18B6B719AE98.e8ed0577.jpeg";